import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-data-transformation-metric',
    templateUrl: './data-transformation-metric.component.html',
    styleUrls: ['./data-transformation-metric.component.scss']
})
export class DataTransformationMetricComponent implements OnInit, OnChanges {
    @Input() plan: any;
    @Input() id: any;
    @Input() startTime: any;
    @Input() showRefreshBtn: any = false;
    isToggled = false;

    @Output() dataEmitter: EventEmitter<any> = new EventEmitter();

    chartData: number[] = [];
    chartLabels = ['Passed', 'Failed', 'Skipped'];
    chartColors = [
        {
            backgroundColor: [
                '#4CAF50', // Green for Passed
                '#F44336', // Red for Failed
                '#FFC107'  // Amber for Skipped
            ],
            borderColor: '#ffffff',
            borderWidth: 1,
            hoverOffset: 4
        }
    ];
    chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 12,
                    font: {
                        size: 12
                    }
                }
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.label || '';
                        let value = context.raw || 0;
                        return `${label}: ${value.toLocaleString()}`;
                    }
                }
            }
        }
    };

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.chartData = [this.plan.passed, this.plan.failed,
            this.plan.skipped];
    }

    refreshData() {
        this.dataEmitter.emit();
    }

    toggleSwitch() {
        console.log('Toggled:', this.isToggled);
        this.dataEmitter.emit(this.isToggled);
    }

}
